<template>
  <SoDialog
    ref="dialog"
    v-model="value"
    card-title="Mark as Deposit Paid"
    data-testid="credit-check-paid-modal"
  >
    <p data-testid="credit-check-paid-modal-message" class="text-body-1 mb-6">
      Are you sure you want to mark the deposit request as Paid for account
      number {{ currentRow.accountNumber }}?
    </p>
    <div class="mt-5 d-flex justify-end">
      <SoButton
        data-testid="credit-check-paid-cancel-btn"
        title="Cancel"
        type="secondary"
        large
        @click="value = false"
      />
      <SoButton
        class="ml-3"
        title="Confirm"
        type="success"
        data-testid="credit-check-paid-submit-btn"
        large
        @click="markAsPaid"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { useSnackbarStore } from "@/stores/snackbar"
  import { errorReporter } from "@/services/ErrorService"
  import { RegistrationCreditChecksService } from "@/services/operations/RegistrationCreditChecksService"
  import { IRegistrationCreditCheck } from "@/models/operations/registrationCreditCheck/registrationCreditCheck.types"
  import { AuthService } from "@/services/AuthService"
  import { formatServerDateTimeNow } from "@/helpers/dateHelper"

  export default defineComponent({
    components: {
      SoButton,
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      currentRow: {
        type: Object as PropType<IRegistrationCreditCheck>,
        default: null,
        required: true,
      },
    },
    emits: ["update:modelValue", "submitted"],
    data() {
      return {
        markAsDepositPaidMutation:
          RegistrationCreditChecksService.markCreditCheckAsDepositPaid(),
        snackbar: useSnackbarStore(),
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      async markAsPaid() {
        const username = AuthService.getCurrentUser().username
        try {
          await this.markAsDepositPaidMutation.mutate({
            id: this.currentRow.id,
            depositAgent: username,
            depositPaidDate: formatServerDateTimeNow(),
          })
          this.value = false
          this.snackbar.addSuccess(
            "Status successfully updated for account " +
              this.currentRow.accountNumber,
          )
          this.$emit("submitted")
        } catch (error) {
          this.snackbar.addError(
            "Failed to update status for account " +
              this.currentRow.accountNumber,
          )
          errorReporter.report(error)
        }
      },
    },
  })
</script>
